import { ChangeDetectionStrategy, Component, HostListener, inject, signal, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { DataService } from '../../../core/services/data.service';
import { AuthService } from '../../../core/services/auth.service';
import { LayoutService } from '../../../core/services/layout.service';

@Component({
  selector: 'app-app-layout-header',
  templateUrl: './header.html',
  styleUrl: './header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
})
export class AppLayoutHeader {
  private dataService = inject(DataService);
  private authService = inject(AuthService);
  readonly layoutService = inject(LayoutService);

  readonly profile = toSignal(this.dataService.profile$, { initialValue: null });
  readonly defaultAvatar = '/images/default-avatar.png';
  readonly isScrolled = signal(false);
  readonly showLogoutModal = signal(false);

  readonly getInitials = computed(() => {
    const p = this.profile();
    if (!p) return '?';
    const f = p.firstName?.trim() || p.fullName?.split(' ')[0] || '';
    const l = p.lastName?.trim() || p.fullName?.split(' ')[1] || '';
    return `${f.charAt(0)}${l.charAt(0)}`.toUpperCase() || '?';
  });

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.isScrolled.set(window.scrollY > 10);
  }

  openLogoutModal(): void {
    this.showLogoutModal.set(true);
  }

  closeLogoutModal(): void {
    this.showLogoutModal.set(false);
  }

  confirmLogout(): void {
    this.showLogoutModal.set(false);
    this.authService.logout();
  }

  onModalBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal')) {
      this.closeLogoutModal();
    }
  }

  /** Expand sidebar from collapsed state (desktop) */
  onToggle(): void {
    this.layoutService.toggleCollapse();
  }

  /** Open sidebar drawer on mobile */
  onMobileToggle(): void {
    this.layoutService.toggle();
  }

  onAvatarError(event: Event): void {
    (event.target as HTMLImageElement).src = this.defaultAvatar;
  }
}
